import React from 'react';
import { StyledErrorFloatCenter, StyledErrorWrap } from '@components/templates/Error/style';

const errorBE = () => {
  return (
    <StyledErrorWrap>
      <StyledErrorFloatCenter>
        <span className={'error_icon'}></span>
        <p className={'error_tit'}>{`This page isn't working`}</p>
        <p className={'error_txt'}>{`currently unable to handle this request.`}</p>
      </StyledErrorFloatCenter>
    </StyledErrorWrap>
  );
};

export default errorBE;
